// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__ZnWdJ","actions":"GroupTable_actions__jOzq6","deleteModalFooter":"GroupTable_deleteModalFooter__f1ZJr"};